import createAction from '.';


export const USER_UPDATED = createAction('USER_UPDATED');

export const onUserUpdates = ({ err, data }) => (dispatch) => {
  if (err) throw (err);

  dispatch({ type: USER_UPDATED, payload: data.userUpdate });
};
